<footer class="bg-[#0f172a] px-4 py-12 text-slate-100 md:px-6 lg:px-8">
    <div class="mx-auto max-w-[96rem]">
        <div class="mb-10 grid grid-cols-1 gap-8 md:grid-cols-4">
            <div>
                <div class="mb-4 flex items-center gap-2">
                    <img
                        src="assets/images/cjc.svg"
                        alt="CJC Public"
                        class="h-9 w-auto object-contain brightness-0 invert"
                    />
                </div>
                <p class="text-sm leading-relaxed text-slate-400">
                    Your one-stop destination for exclusive client deals and
                    offers.
                </p>
                <div class="mt-4 flex items-center gap-3">
                    <a
                        href="#"
                        class="flex h-9 w-9 items-center justify-center rounded-full bg-slate-800 text-slate-300 transition-all duration-300 hover:bg-[#1587e8] hover:text-white"
                    >
                        <svg
                            class="h-4 w-4"
                            fill="currentColor"
                            viewBox="0 0 24 24"
                        >
                            <path
                                d="M24 4.557c-.883.392-1.832.656-2.828.775 1.017-.609 1.798-1.574 2.165-2.724-.951.564-2.005.974-3.127 1.195-.897-.957-2.178-1.555-3.594-1.555-3.179 0-5.515 2.966-4.797 6.045-4.091-.205-7.719-2.165-10.148-5.144-1.29 2.213-.669 5.108 1.523 6.574-.806-.026-1.566-.247-2.229-.616-.054 2.281 1.581 4.415 3.949 4.89-.693.188-1.452.232-2.224.084.626 1.956 2.444 3.379 4.6 3.419-2.07 1.623-4.678 2.348-7.29 2.04 2.179 1.397 4.768 2.212 7.548 2.212 9.142 0 14.307-7.721 13.995-14.646.962-.695 1.797-1.562 2.457-2.549z"
                            />
                        </svg>
                    </a>
                    <a
                        href="#"
                        class="flex h-9 w-9 items-center justify-center rounded-full bg-slate-800 text-slate-300 transition-all duration-300 hover:bg-[#1587e8] hover:text-white"
                    >
                        <svg
                            class="h-4 w-4"
                            fill="currentColor"
                            viewBox="0 0 24 24"
                        >
                            <path
                                d="M12.017 0C5.396 0 .029 5.367.029 11.987c0 5.079 3.158 9.417 7.618 11.162-.105-.949-.199-2.403.041-3.439.219-.937 1.406-5.957 1.406-5.957s-.359-.72-.359-1.781c0-1.668.967-2.914 2.171-2.914 1.023 0 1.518.769 1.518 1.69 0 1.029-.655 2.568-.994 3.995-.283 1.194.599 2.169 1.777 2.169 2.133 0 3.772-2.249 3.772-5.495 0-2.873-2.064-4.882-5.012-4.882-3.414 0-5.418 2.561-5.418 5.207 0 1.031.397 2.138.893 2.738a.36.36 0 01.083.345l-.333 1.36c-.053.22-.174.267-.402.161-1.499-.698-2.436-2.889-2.436-4.649 0-3.785 2.75-7.262 7.929-7.262 4.163 0 7.398 2.967 7.398 6.931 0 4.136-2.607 7.464-6.227 7.464-1.216 0-2.359-.631-2.75-1.378l-.748 2.853c-.271 1.043-1.002 2.35-1.492 3.146C9.57 23.812 10.763 24 12.017 24 18.635 24 24 18.633 24 12.013 24 5.393 18.635.026 12.017.026V0z"
                            />
                        </svg>
                    </a>
                    <a
                        href="#"
                        class="flex h-9 w-9 items-center justify-center rounded-full bg-slate-800 text-slate-300 transition-all duration-300 hover:bg-[#1587e8] hover:text-white"
                    >
                        <svg
                            class="h-4 w-4"
                            fill="currentColor"
                            viewBox="0 0 24 24"
                        >
                            <path
                                d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z"
                            />
                        </svg>
                    </a>
                    <a
                        href="#"
                        class="flex h-9 w-9 items-center justify-center rounded-full bg-slate-800 text-slate-300 transition-all duration-300 hover:bg-[#1587e8] hover:text-white"
                    >
                        <svg
                            class="h-4 w-4"
                            fill="currentColor"
                            viewBox="0 0 24 24"
                        >
                            <path
                                d="M19.615 3.184c-3.604-.246-11.631-.245-15.23 0-3.897.266-4.356 2.62-4.385 8.816.029 6.185.484 8.549 4.385 8.816 3.6.245 11.626.246 15.23 0 3.897-.266 4.356-2.62 4.385-8.816-.029-6.185-.484-8.549-4.385-8.816zm-10.615 12.816v-8l8 3.993-8 4.007z"
                            />
                        </svg>
                    </a>
                </div>
            </div>
            <div>
                <h4 class="mb-4 font-semibold text-white">Quick Links</h4>
                <ul class="space-y-2.5 text-sm text-slate-300">
                    <li>
                        <a
                            routerLink="/home"
                            class="transition-colors hover:text-[#1587e8]"
                            >Home</a
                        >
                    </li>
                    <li>
                        <a
                            routerLink="/home"
                            class="transition-colors hover:text-[#1587e8]"
                            >Deals</a
                        >
                    </li>
                    <li>
                        <a
                            routerLink="/home"
                            class="transition-colors hover:text-[#1587e8]"
                            >Categories</a
                        >
                    </li>
                    <li>
                        <a
                            routerLink="/home"
                            class="transition-colors hover:text-[#1587e8]"
                            >Brands</a
                        >
                    </li>
                    <li>
                        <a
                            routerLink="/contact"
                            class="transition-colors hover:text-[#1587e8]"
                            >Contact</a
                        >
                    </li>
                </ul>
            </div>
            <div>
                <h4 class="mb-4 font-semibold text-white">Support</h4>
                <ul class="space-y-2.5 text-sm text-slate-300">
                    <li>
                        <a
                            routerLink="/help-center"
                            class="transition-colors hover:text-[#1587e8]"
                            >Help Center</a
                        >
                    </li>
                    <li>
                        <a
                            routerLink="/faqs"
                            class="transition-colors hover:text-[#1587e8]"
                            >FAQs</a
                        >
                    </li>
                    <li>
                        <a
                            routerLink="/terms"
                            class="transition-colors hover:text-[#1587e8]"
                            >Terms of Service</a
                        >
                    </li>
                    <li>
                        <a
                            routerLink="/privacy"
                            class="transition-colors hover:text-[#1587e8]"
                            >Privacy Policy</a
                        >
                    </li>
                    <li>
                        <a
                            href="#"
                            class="transition-colors hover:text-[#1587e8]"
                            >Refund Policy</a
                        >
                    </li>
                </ul>
            </div>
            <div>
                <h4 class="mb-4 font-semibold text-white">Contact Us</h4>
                <ul class="space-y-3 text-sm text-slate-300">
                    <li class="flex items-start gap-2">
                        <svg
                            class="mt-0.5 h-4 w-4 text-[#1587e8]"
                            fill="none"
                            stroke="currentColor"
                            viewBox="0 0 24 24"
                        >
                            <path
                                stroke-linecap="round"
                                stroke-linejoin="round"
                                stroke-width="2"
                                d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"
                            />
                        </svg>
                        <span>support&#64;company.com</span>
                    </li>
                    <li class="flex items-start gap-2">
                        <svg
                            class="mt-0.5 h-4 w-4 text-[#1587e8]"
                            fill="none"
                            stroke="currentColor"
                            viewBox="0 0 24 24"
                        >
                            <path
                                stroke-linecap="round"
                                stroke-linejoin="round"
                                stroke-width="2"
                                d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z"
                            />
                        </svg>
                        <span>1-800-BENEFITS</span>
                    </li>
                    <li class="flex items-start gap-2">
                        <svg
                            class="mt-0.5 h-4 w-4 text-[#1587e8]"
                            fill="none"
                            stroke="currentColor"
                            viewBox="0 0 24 24"
                        >
                            <path
                                stroke-linecap="round"
                                stroke-linejoin="round"
                                stroke-width="2"
                                d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z"
                            />
                            <path
                                stroke-linecap="round"
                                stroke-linejoin="round"
                                stroke-width="2"
                                d="M15 11a3 3 0 11-6 0 3 3 0 016 0z"
                            />
                        </svg>
                        <span>123 Business Ave, Suite 100</span>
                    </li>
                </ul>
            </div>
        </div>
        <div
            class="flex flex-col items-center justify-between gap-4 border-t border-slate-800 pt-6 md:flex-row"
        >
            <p class="text-sm text-slate-400">
                &copy; 2026 ChakrijibiClub. All rights reserved.
            </p>
            <div class="flex items-center gap-4 text-sm text-slate-400">
                <a
                    routerLink="/terms"
                    class="transition-colors hover:text-white"
                    >Terms</a
                >
                <a
                    routerLink="/privacy"
                    class="transition-colors hover:text-white"
                    >Privacy</a
                >
                <a href="#" class="transition-colors hover:text-white"
                    >Cookies</a
                >
            </div>
        </div>
    </div>
</footer>
